<template>
    <div>
        <Panel :title="$t('User Organisation Views')">
            <ul class="item-form" style="text-align: left; background-color: #eee; padding: 10px 0 10px 16px">
                <li class="form-label-first">{{ $t('User') }}</li>
                <li>
                    <CicSelect
                        id="view_user"
                        :value="userId"
                        :options="users.map((user) => ({ value: user.userId, label: user.username }))"
                        @input="loadViews"
                    />
                </li>
            </ul>
            <table v-if="userId" id="organisations_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Organisation') }}</th>
                        <th>{{ $t('Access') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="organisation in organisations">
                        <td>{{ organisation.name }}</td>
                        <td>
                            <CicCheckbox
                                :value="!selected.includes(organisation.orgId)"
                                @input="handleSelected(organisation.orgId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <template v-if="userId" #footer>
                <CicButton id="save_views" @click="saveItem">{{ $t('Save') }}</CicButton>
            </template>
        </Panel>

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicSelect from '@/components/inputs/CicSelect';
    import { load, save } from '@/utils/Http';

    export default {
        name: 'UserViews',
        components: {
            CicSelect,
            CicButton,
            CicCheckbox,
            Panel,
        },
        data() {
            return {
                organisations: [],
                selected: [],
                userId: null,
                users: [],
            };
        },
        created() {
            this.loadUsers();
        },
        methods: {
            handleSelected(itemId) {
                if (this.selected.indexOf(itemId) !== -1) {
                    this.selected.splice(this.selected.indexOf(itemId), 1);
                } else {
                    this.selected.push(itemId);
                }
            },
            loadUsers() {
                load('organisation/portalusers', { orgId: this.$store.user.orgId }, (response) => {
                    this.users = response.users;
                });
            },
            loadViews(userId) {
                this.userId = userId;
                this.selected = [];
                if (this.organisations.length === 0) {
                    load('userviews/organisations', {}, (response) => {
                        this.organisations = response.organisations;
                    });
                }
                load('userviews/get', { userId }, (response) => {
                    this.selected = response.orgIds;
                });
            },
            saveItem() {
                save('userviews/update', { userId: this.userId, orgIds: JSON.stringify(this.selected) }, () => {
                    this.loadViews(this.userId);
                });
            },
        },
    };
</script>
